import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';

@Injectable()
export class VendorService {
  private rootUrl = environment.API_URL || '';
  private shopId: string;

  constructor(private httpClient: HttpClient) {
    this.shopId = localStorage.getItem('userID') || '';
  }

  getList(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/vendor/list`,  { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        console.error('Error fetching vendor list', error);
        throw error;
      });
  }

  create(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/vendor/create`, { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        console.error('Error creating vendor', error);
        throw error;
      });
  }

  getDetails(vendorId: string): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/vendor/edit`, { vendor_id: vendorId, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        console.error('Error fetching vendor details', error);
        throw error;
      });
  }

  update(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/vendor/update`, { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        console.error('Error updating vendor', error);
        throw error;
      });
  }

  status(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/vendor/status`, { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        console.error('Error updating vendor status', error);
        throw error;
      });
  }

  delete(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/vendor/delete`, { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        console.error('Error deleting vendor', error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/vendor.service.ts